import { SVGProps } from 'react';

const Currency = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m3 3 3 3m15-3-3 3M3 21l3-3m15 3-3-3m2-6a8 8 0 1 1-16 0 8 8 0 0 1 16 0"
    />
  </svg>
);
export default Currency;
